<template>
    <div class="wrap">
        <listHeader
            :title="title"
            :scenario="scenario"
            :operate="showOperate"
            :back="back"
            @optionFun="headerOptionFun"
        >
        </listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="class"
                active="student"
                :cbid="postData.cbid"
                v-if="postData.cbid"
            ></hro-tab>

            <search-screen
                :checkData="postData"
                :set-condition="{
                    pagesize: setCondition.pagesizes,
                    field: setCondition.fields,
                }"
                :config="config"
                :scenario="scenario"
                @exportRes="exportRes(0)"
                @setOption="setOption"
                @clear="clear"
                @search="search"
            >
            </search-screen>

            <div class="hro-table hro-table-only">
                <hro-table
                    :columns="columns"
                    :dataSource="data"
                    :loading="loading"
                    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                    :scroll="scroll"
                    :rowKey="selectedKey"
                    :operate="showOperate"
                    @actionFun="actionFun"
                >

                </hro-table>
            </div>
        </div>

        <list-bottom
            :page="postData.page"
            :pagesize="postData.pagesize"
            :total="total"
            :data="data"
            :selectedRowKeys="selectedRowKeys"
            :condition="{
                  checkall: true,
              }"
            :scenario="scenario"
            :operate="showOperate"
            @checked="onCheckAllChange"
            @page="pageTo"
            @optionFun="bottomOptionFun"
        >
        </list-bottom>

        <!--结业-->
        <cstudent-finish
            v-model="showModal"
            :csid="csid"
            @confirm="getData">
        </cstudent-finish>

    </div>
</template>

<script>
import $ from 'jquery';
import searchScreen from '@/components/list/searchScreen';
import listBottom from '@/components/list/listBottom';
import hroTable from '@/components/list/table';
import listHeader from '@/components/list/listHeader';
import cstudentFinish from '@/components/modal/cstudentFinish';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listBottom,
        hroTable,
        searchScreen,
        listHeader,
        cstudentFinish,
        hroTab,
    },
    data() {
        return {
            title: '学员列表',
            scenario: 'cstudentList', // 页面标识
            selectedRowKeys: [], // 选中行的key
            selectedRowKeysItem: [], // 选中行的item
            selectedKey: 'csid', // 数据主键字段（唯一）
            loading: false,// 请求
            scroll: null, //滚动
            data: [],
            setCondition: {
                fields: [],// 显示字段
                pagesizes: {},// 每页显示数筛选条件
            },
            postData: {
                cbid: '',
                keyword: '',
                status: '',
                page: 1,
                pagesize: 10,
                showfield: [], // 显示字段
            },
            total: 0,
            config: {},
            tplinfo: [],
            showModal: false, // 弹框
            showOperate: '1', // 显示操作按钮, 1 显示默认操作
            back: false,
            csid: '',
        }
    },
    computed: {
        columns() {
            // 处理显示字段
            let columns = [];
            for (let i in this.setCondition.fields) {
                let index = this.inArray(this.setCondition.fields[i].key, this.postData.showfield);
                if (index > -1) {
                    let item = {
                        title: this.setCondition.fields[i].text,
                        dataIndex: this.setCondition.fields[i].key,
                    };

                    if (i == 0 && this.setCondition.fields[i].default == 1) {
                        item.fixed = 'left';
                    }

                    if (this.setCondition.fields[i].key == 'csname') {
                        item.scopedSlots = {customRender: 'cstudent_name'};
                        item.width = 200;
                    }

                    columns.push(item);
                }
            }

            let item = {
                title: '操作',
                dataIndex: 'cstudent_action',
                scopedSlots: {customRender: 'cstudent_action'},
                width: 140,
            };

            let len = columns.length;
            if (len >= 7) {
                item.fixed = 'right';
            } else if (len > 0 && len < 7) {
                columns[0].fixed = '';
            }
            columns.push(item);

            let x = 300 + (len - 2) * 150;
            let table_width = $('.hro-table').width();
            this.scroll = x > table_width ? {x: x} : null;

            return columns;
        }
    },
    watch: {
        '$store.state.showLayoutMenu'(val) {
            $('.list-bottom').width($('.wrap-list-content').width());
        },
    },
    created() {
        // 当浏览器大小变化时
        this.listenListWindow();

        // 初始化postData
        this.setData();

        // 请求数据
        this.getData();

        // 显示创建按钮
        if (this.postData.cbid == '') {
            this.showOperate = '';
        } else {
            this.back = true;
        }
    },
    methods: {
        getData() {
            // init
            this.selectedRowKeys = [];

            // 加载等待
            this.loading = true;
            this.http('/manage/cstudent/list', this.postData, (res) => {
                this.loading = false;

                // 数据渲染
                this.setCondition.fields = res['_fields'];
                this.setCondition.pagesizes = res['_pagesizes'];
                this.data = res.list.data;
                this.total = parseInt(res.list.count);
                this.postData.pagesize = parseInt(res.list.pagesize);
                this.config = res.config;

                // 初始化底部宽度
                this.$nextTick(() => {
                    $('.list-bottom').width($('.wrap-list-content').width());
                });
            }, null, 2);
        },
        // 设置参数
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;

                if (i === 'showfield') {
                    this.postData[i] = typeof this.$route.query[i] === 'string' ? [this.$route.query[i]] : this.$route.query[i];
                } else {
                    this.postData[i] = this.$route.query[i];
                }
            }

            // 初始化显示字段
            if (this.$route.query['showfield'] === undefined) {
                this.postData['showfield'] = ['csname', 'mobile', 'cname', 'finishtime_str', 'status_str', 'addtime_str'];
            }
        },
        // 头部操作
        headerOptionFun(e) {
            switch (e.op) {
                case 'create':
                    if (this.postData.cbid) {
                        this.$router.push('/cstudent/create?cbid=' + this.postData.cbid);
                    }
                    break;
                default:
                    break;
            }
        },
        // 列表操作
        actionFun(e) {
            switch (e.op) {
                case 'edit': // 编辑
                    this.$router.push('/cstudent/edit?cbid=' + e.cbid + '&csid=' + e.csid);
                    break;
                case 'lesson': // 课程
                    this.$router.push('/clesson/student?cbid=' + e.cbid + '&csid=' + e.csid);
                    break;
                case 'close':// 关闭
                    this.confirm({title: '删除学员', content: `确认删除该学员？`}, () => {
                        this.http('/manage/cstudent/close', {csid: e.csid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                case 'open':// 开启
                    this.confirm({title: '恢复学员', content: `确认恢复该学员？`}, () => {
                        this.http('/manage/cstudent/open', {csid: e.csid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                default:
                    break;
            }
        },
        // 底部操作
        bottomOptionFun(e) {
            if (this.selectedRowKeys.length === 0) {
                return false;
            }

            switch (e.op) {
                case 'finish':
                    this.csid = this.selectedRowKeys.join(',');
                    this.showModal = true;
                    break;
                default:
                    break;
            }
        },
        backRouter() {
            this.$router.go(-1);
        }
    },
}
</script>


<style lang="less" src="../../assets/css/list/list.less"></style>
